import React from 'react';
import PropTypes from 'prop-types';

/**
 * SkeletonText Component
 * 
 * A flexible text skeleton for loading states.
 * 
 * @param {Object} props
 * @param {string} props.size - Size variant: 'xs' | 'sm' | 'base' | 'lg' | 'xl'
 * @param {string} props.width - Width class: 'w-16' | 'w-24' | 'w-32' | 'w-48' | 'w-full'
 * @param {string} props.className - Additional CSS classes
 * @component
 */
export default function SkeletonText({ 
  size = 'base', 
  width = 'w-24', 
  className = '' 
}) {
  const sizeClasses = {
    xs: 'h-3',
    sm: 'h-4',
    base: 'h-4',
    lg: 'h-5',
    xl: 'h-6'
  };

  return (
    <div
      className={`bg-gray-200 rounded animate-pulse ${sizeClasses[size]} ${width} ${className}`}
      aria-label="Loading text"
    />
  );
}

SkeletonText.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'base', 'lg', 'xl']),
  width: PropTypes.string,
  className: PropTypes.string,
};